import React from 'react';
import { bool, oneOf, string } from 'prop-types';
import { FormattedMessage, intlShape, injectIntl } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

const LineItemTaxMaybe = props => {
  const { lineItems, isProvider, intl } = props;

  const taxLineItems = lineItems.filter(item => {
    const isTaxItem = item.code.match(/^line-item\/(gst|pst|hst|qst|rst)$/);
    return isTaxItem && !item.reversal;
  });

  if (taxLineItems.length === 0) {
    return null;
  }

  const formatTaxName = (code) => {
    const taxNames = {
      'line-item/gst': 'GST',
      'line-item/pst': 'PST', 
      'line-item/hst': 'HST',
      'line-item/qst': 'QST',
      'line-item/rst': 'RST'
    };
    return taxNames[code] || code.replace('line-item/', '').toUpperCase();
  };

  return (
    <>
      {taxLineItems.map((item, index) => {
        const formattedPrice = formatMoney(intl, item.unitPrice);
        const taxName = formatTaxName(item.code);
        
        return (
          <div key={`${item.code}-${index}`} className={css.lineItem}>
            <span className={css.itemLabel}>
              <FormattedMessage id="LineItemTaxMaybe.label" values={{ taxType: taxName }} />
            </span>
            <span className={css.itemValue}>{formattedPrice}</span>
          </div>
        );
      })}
    </>
  );
};

LineItemTaxMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  isProvider: bool.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemTaxMaybe;
